export function booleanAttributeConverter() {
    return {
        fromAttribute: (value: string) => {       
            return value == "true";
        },
        toAttribute: (value: boolean) => {
            return value;
        }
    };
}

export interface IClassMap {
    [key: string]: boolean;
}

export type AtlantisEvent<TEvent = Event, T = HTMLElement> = TEvent & { target: T };